const saltRequirementMultiplier = 2 / 3

export const getSaltRequirementsForFermentationRecipe = (
  fermentationRecipe: farmhand.item
): number => {
  const { daysToFerment = 0, tier = 1 } = fermentationRecipe

  return Math.ceil((daysToFerment ?? 0) * saltRequirementMultiplier) * tier
}
